import React from 'react';
import { SubHeader } from '../styled';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { LabelTab } from './styled';
import { TABS } from '../..';

export const TabChats = ({
  countChatsInWait,
  countAttributedChats,
  activeTab,
  setActiveTab,
  countChatsInAttendance
}) => {
  const isActive = (tab) => {
    return activeTab === tab
      ? {
          active: true
        }
      : {
          active: false
        };
  };
  return (
    <SubHeader className="mt-2 mb-2">
      <Nav tabs={true}>
        <NavItem>
          <NavLink
            className={classnames(isActive(TABS.IN_WAIT), 'px-2')}
            id="AllAwaiting"
            onClick={() => {
              setActiveTab(TABS.IN_WAIT);
            }}
          >
            <LabelTab className="display-6">
              Em espera: {countChatsInWait}
            </LabelTab>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames(isActive(TABS.ATTRIBUTED), 'px-2')}
            id="AllAwaiting"
            onClick={() => {
              setActiveTab(TABS.ATTRIBUTED);
            }}
          >
            <LabelTab className="display-6">
              Atribuido: {countAttributedChats}
            </LabelTab>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames(isActive(TABS.IN_ATTENDANCE), 'px-2')}
            id="AllAttendance"
            onClick={() => {
              setActiveTab(TABS.IN_ATTENDANCE);
            }}
          >
            <LabelTab className="display-6">
              Em atendimento: {countChatsInAttendance}
            </LabelTab>
          </NavLink>
        </NavItem>
      </Nav>
    </SubHeader>
  );
};
